module.exports = __webpack_public_path__ + "img/img-cd3a9f0a.c180d5cd.png";